import React from "react";
import { NavLink } from "react-router-dom";
import "../../../css/Topbar.css";

const TopbarCenterManagement: React.FC = () => {
  return (
    <div className="admin-center-topbar">
      <NavLink
        to="/release-appointment"
        className={({ isActive }) =>
          isActive ? "admin-center-tab active" : "admin-center-tab"
        }
      >
        Create Appointment
      </NavLink>
      <NavLink
        to="/add-stations"
        className={({ isActive }) =>
          isActive ? "admin-center-tab active" : "admin-center-tab"
        }
      >
        Release Appointment
      </NavLink>
      <NavLink
        to="/edit-appointment"
        className={({ isActive }) =>
          isActive ? "admin-center-tab active" : "admin-center-tab"
        }
      >
        Edit Appointment
      </NavLink>
      <NavLink
        to="/edit-log"
        className={({ isActive }) =>
          isActive ? "admin-center-tab active" : "admin-center-tab"
        }
      >
        View Logs
      </NavLink>
    </div>
  );
};

export default TopbarCenterManagement;
